<script setup>
import { ref, watch } from 'vue';
import eventBus from '../eventBus';

// logo 設置 opacity 顯藏
const logoOpacity = ref(1);
watch(() => eventBus.logoOpacity, opacity => logoOpacity.value = opacity);
</script>

<template>
    <div class="min-vh-100 d-flex flex-column">
        <header class="header d-flex">
            <img id="logo"
                class="logo ml-auto"
                src="/images/ApplicationLogo.png"
                alt="logo"
                :style="{ opacity: logoOpacity }"
            >
        </header>
        <main class="d-flex flex-grow-1">
            <slot/>
        </main>
    </div>
</template>
